import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import getBaseUrl from "./getBaseUrl";

const maxCacheInSeconds = 0;
const maxRetries = 2;

const dynamicBaseQuery = async (args: any, api: any, extraOptions: any) => {
  const rawBaseQuery = fetchBaseQuery({ baseUrl: getBaseUrl() });
  return rawBaseQuery(args, api, extraOptions);
};

const baseQuery = retry(dynamicBaseQuery, { maxRetries });

export const countriesStatesCitiesAPI = createApi({
  reducerPath: "countriesStatesCitiesAPI",
  baseQuery,
  keepUnusedDataFor: maxCacheInSeconds,
  endpoints: (builder) => ({
    //* ************************************** */
    //* GET ALL COUNTRIES */
    getCountries: builder.mutation({
      query: () => ({
        url: "https://countriesnow.space/api/v0.1/countries/codes",
        method: "get",
      }),
    }),
    //* ************************************** */
    //* GET ALL STATES */
    getStates: builder.mutation({
      query: (country: string) => ({
        url: "https://countriesnow.space/api/v0.1/countries/states",
        method: "post",
        body: { country },
      }),
    }),
    //* ************************************** */
    //* GET ALL CITIES */
    getCities: builder.mutation({
      query: (body: any) => ({
        url: "https://countriesnow.space/api/v0.1/countries/state/cities",
        method: "post",
        body,
      }),
    }),
  }),
});

export const { useGetCountriesMutation, useGetCitiesMutation, useGetStatesMutation } =
  countriesStatesCitiesAPI;
